import { ChatThreadTypeEnum } from 'common-utils';
import { ChatThreadRI, StudentContactInfo } from 'common-utils/rest-interfaces';
import { mergeMap, map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { of } from 'rxjs';
import { AjaxResponse } from './interfaces/AjaxResponse';
import { CommunicationNotificationItemGroup } from './models/communication-notification-item-group';
import { pdsHttpUtils } from './pds-http-utils';
import { PdsWidget } from './pds-widget';
import { ChatThreadService } from './services/chat-thread-service';

export class PdsCommunicationNotification extends PdsWidget {
  is = 'pds-communication-notification';

  notificationGroup: CommunicationNotificationItemGroup;
  getS3MediaPath: () => string;

  isParentContactInfo: boolean;
  selectedStudentUid: string;

  isQuickMessageDialogOpen: boolean;
  quickMessageDialogThreadRI: ChatThreadRI;
  private chatThreadService = new ChatThreadService();

  ready(): void {
    super.ready();
    this.getS3MediaPath = this.pds.preferences.getS3MediaPath;
    this.isQuickMessageDialogOpen = false;
  }

  messageKeysUpdated(): void { }

  emitClickEvent(event: any): void {
    event.preventDefault();
    let threadInfo = this.notificationGroup.getThreadContext();
    this.selectedStudentUid = threadInfo.topicUid; // topicaUid is the studentUid.
    pdsHttpUtils.get(`${this.pds.preferences.host}/communication/v1/thread/${threadInfo.threadUid}`, {}, pdsHttpUtils.addUCAuthHeader({}))
      .subscribe((response: AjaxResponse) => {
        this.quickMessageDialogThreadRI = JSON.parse(response.data);
        this.checkForParentContactInfo();
        this.isQuickMessageDialogOpen = true;
        setTimeout(() => {
          this.querySelector('pds-chat-quick-message').addEventListener('pdsRemoveDialog', () => {
            this.isQuickMessageDialogOpen = false;
          });
        });
      });
  }

  checkForParentContactInfo(): void {
    pdsHttpUtils.post(`${this.pds.preferences.host}/communication/v1/students/contactInfo`, { studentUids: new Array(this.selectedStudentUid) }, {}, pdsHttpUtils.addUCAuthHeader({}))
      .subscribe((response: AjaxResponse) => {
        let studentContactInfo: Array<StudentContactInfo> = JSON.parse(response.data);
        this.isParentContactInfo = studentContactInfo.length === 1;
      });
  }

  getMessages(notificationGroup: CommunicationNotificationItemGroup): any {
    return notificationGroup.messages;
  }

  handleChatTabChange(event): void {
    let threadObs: Observable<ChatThreadRI>;
    let thread: any = {
      uid: '',
      name: this.quickMessageDialogThreadRI.name,
      ownerUid: this.quickMessageDialogThreadRI.ownerUid,
      ownerUserType: this.quickMessageDialogThreadRI.ownerUserType,
      topicUid: this.quickMessageDialogThreadRI.topicUid
    };

    if (event.detail === 'STUDENT_TAB') {
      threadObs = of([{ userUid: this.quickMessageDialogThreadRI.topicUid, userType: 'STUDENT' }, { userUid: this.quickMessageDialogThreadRI.ownerUid, userType: 'TEACHER' }]).pipe(
        mergeMap((participants) => {
          thread.participants = participants;
          thread.threadType = ChatThreadTypeEnum.STUDENT_TEACHER;
          return this.chatThreadService.fetchTopicThread(this.pds.preferences.host, thread);
        }));
    } else {
      threadObs = this.chatThreadService.fetchParentParticipants(this.pds.preferences.host, this.quickMessageDialogThreadRI.topicUid!).pipe(
        mergeMap((participants) => {
          thread.participants = participants;
          thread.threadType = ChatThreadTypeEnum.TEACHER_PARENT;
          return this.chatThreadService.fetchTopicThread(this.pds.preferences.host, thread);
        }));
    }
    threadObs
      .subscribe((chatThread: ChatThreadRI) => {
        this.quickMessageDialogThreadRI = chatThread;
        setTimeout(() => {
          let containerEl = <HTMLElement>this.querySelector('.pds-chat-message-container');
          containerEl.scrollTop = containerEl.scrollHeight;
        });
      });
  }
}
